"use client";

import FaqAccordion from "@/components/FaqAccordion";

export default function CityFaqClient({ customFaqData, customTitle }) {
  return (
    <div className="bg-background-global w-full py-5 md:py-18">
      <div className="container">
        <FaqAccordion
          customFaqData={customFaqData}
          dataType="cityDynamic"
          customTitle={customTitle}
        />
      </div>
    </div>
  );
}
